import {
  ContactDetailsArrayKey,
  ContactDetailsItem,
  PersonContactDetails,
  PersonContactDetailsUpdate,
} from '~/common/types/people';
import { detailsArrayKeys, getTempContactDetailItem } from '~/common/utils/people';

import { ContactDetailsFormValues } from './config';

export const getInitialFormValues = (
  person?: Partial<PersonContactDetails>,
): ContactDetailsFormValues => {
  const mapItemsToValues = (details: ContactDetailsItem[] = []) =>
    details.map(({ value }) => value);

  return detailsArrayKeys.reduce(
    (formValues, key) => ({
      ...formValues,
      [key]: mapItemsToValues(person?.[key]),
    }),
    <ContactDetailsFormValues>{},
  );
};

export const formValuesToUpdatePayload = (
  { personId, ...person }: Partial<PersonContactDetails> & { personId: number },
  values: ContactDetailsFormValues,
) => {
  const update: PersonContactDetailsUpdate = {
    personId,
    contactDetails: [],
    deleteContactDetailsIds: [],
  };

  const handleValues = (arrayKey: ContactDetailsArrayKey) => {
    const itemsArray = person[arrayKey] || [];
    const valuesArray = [...new Set(values[arrayKey])]; // Discard duplicate values
    const updateArray = update.contactDetails;

    const valuesCount = Math.max(itemsArray.length, valuesArray.length);

    for (let i = 0; i < valuesCount; i++) {
      const existingItem = itemsArray[i];
      const formValue = valuesArray[i];

      if (existingItem && formValue) {
        updateArray.push({ ...existingItem, value: formValue });
      } else if (formValue) {
        updateArray.push(getTempContactDetailItem(arrayKey, personId, formValue));
      } else if (existingItem) {
        update.deleteContactDetailsIds.push(existingItem.detailsId);
      }
    }
  };

  detailsArrayKeys.forEach(handleValues);

  return update;
};
